import { ProductHistoryActions, ProductHistoryActionsType } from "./product-history.actions";
import { ProductHistoryState } from "../types/product-history.interface";
import { createProductHistoryState } from "../types/product-history.functions";

export const productHistoryReducer = (
  state: ProductHistoryState = createProductHistoryState(),
  action: ProductHistoryActionsType
) => {
  switch (action.type) {
    case ProductHistoryActions.ProductHistoryClear:
      return createProductHistoryState();

    case ProductHistoryActions.ProductHistoryFetch:
    case ProductHistoryActions.ProductHistoryNext:
      return {
        ...state,
        loading: true,
      };

    case ProductHistoryActions.ProductHistoryFetchFailure:
    case ProductHistoryActions.ProductHistoryNextFailure:
      return {
        ...state,
        errors: action.payload,
        loading: false,
      };

    case ProductHistoryActions.ProductHistoryFetchSuccess:
      return {
        ...state,
        history: action.payload,
        loading: false,
      };

    case ProductHistoryActions.ProductHistoryNextSuccess:
      return {
        ...state,
        history: {
          ...action.payload,
          results: [...state.history!.results, ...action.payload.results],
        },
        loading: false,
      };

    default:
      return state;
  }
};
